export default __webpack_public_path__ + "static/media/feature-box-collection-cassas-550x310.1b69a924.jpg";